module.exports = __webpack_public_path__ + "logo.8efbf6448162bb80b15908e8f92c4ee6.png";